import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Document, Page, pdfjs } from 'react-pdf';
import { Button, Modal, Row, Col } from 'antd';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const VisualizerGuiadePDF = ({ open, callback, pdfGuia }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  // Callback para manejar la carga del documento
  // eslint-disable-next-line no-shadow
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  // Navegación de páginas
  const nextPage = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  const prevPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  // Función para descargar el PDF completo
  const downloadPDF = () => {
    const link = document.createElement('a');
    link.href = `data:application/pdf;base64,${pdfGuia}`;
    link.download = 'Guía.pdf';
    link.click();
  };

  const handleCancel = () => {
    callback(false);
  };
  console.log(pdfGuia, 'pdfGuia');
  return (
    <Modal footer={null} width="50%" open={open} onCancel={handleCancel} centered>
      <Row>
        <Col span={24}>
          <h2
            style={{
              margin: '0px 20px 10px 20px',
              fontFamily: 'Arial, sans-serif',
              fontSize: '1rem',
              fontWeight: '600',
              color: '#c12b7d'
            }}>
            Guía de usuario
          </h2>
        </Col>
      </Row>
      <div
        style={{
          overflowY: 'auto',
          height: '500px', // Ajusta la altura según sea necesario
          padding: '10px 20px',
          border: '1px solid #eaeaea',
          borderRadius: '5px',
          backgroundColor: '#f9f9f9'
        }}>
        <Document
          file={`data:application/pdf;base64,${pdfGuia}`}
          onLoadSuccess={onDocumentLoadSuccess}>
          <Page pageNumber={pageNumber} scale={1.2} />
        </Document>
      </div>
      <div style={{ marginTop: 20, textAlign: 'center' }}>
        <Button onClick={prevPage} disabled={pageNumber <= 1} style={{ marginRight: 10 }}>
          Anterior
        </Button>
        <Button onClick={nextPage} disabled={pageNumber >= numPages} style={{ marginLeft: 10 }}>
          Siguiente
        </Button>
        <p style={{ margin: 10 }}>
          Página {pageNumber} de {numPages}
        </p>
        <Button type="primary" onClick={downloadPDF}>
          Descargar PDF
        </Button>
      </div>
    </Modal>
  );
};

VisualizerGuiadePDF.propTypes = {
  open: PropTypes.bool.isRequired,
  callback: PropTypes.func.isRequired,
  pdfGuia: PropTypes.string // Asume que el contenido es base64
};

VisualizerGuiadePDF.defaultProps = {
  pdfGuia: null
};

export { VisualizerGuiadePDF };
